// extracted by mini-css-extract-plugin
export default {"wrapper":"HomePageImages_wrapper__3e40z","wrapperWhenSmall":"HomePageImages_wrapperWhenSmall__MStGI","bigBox":"HomePageImages_bigBox__Fm0FT","box":"HomePageImages_box__05hob"};